import { email as getEmailErrorString } from 'redux-form-validators'

export const BUSINESS_EMAIL_ERROR = 'Please enter a business email address.'
const BLOCKED_EMAIL_ERROR = 'This email address cannot be used with Ramp.'

// Keep in sync with suma/apps/utils/__init__.py on the backend
const personalEmailDomains = [
  '@gmail.com',
  '@outlook.com',
  '@yahoo.com',
  '@icloud.com',
  '@hotmail.com',
  '@aol.com',
  '@msn.com',
  '@me.com',
  '@live.com',
  '@att.net',
  '@comcast.net',
  '@gmx.com',
  '@googlemail.com',
  '@hotmail.co.uk',
  '@yahoo.co.uk',
  '@mail.com',
  '@rocketmail.com',
  '@protonmail.com',
  '@zoho.com',
  '@yandex',
  '@safe-mail.net',
  '@lavabit.com',
  '@currently.com',
]

// Blocked domains are rejected in all validators (even when personal domains are allowed)
const blockedEmailDomains = [
  '123mails.org',
  '163.com',
  '47053d33b32c267b2a0575a8346365d6.com',
  'aabkmail.com',
  'aboodbab.com',
  'advantagesolutions.net',
  'aim.com',
  'ainating.com',
  'aiphotoeditor.io',
  'aiphotoenhancer.me',
  'amazon.com',
  'aminating.com',
  'anogz.com',
  'apple.com',
  'bdm.ovh',
  'beltvalleybank.com',
  'bill.com',
  'biz.com',
  'bltiwd.com',
  'bluzora.site',
  'bpl-tv.live',
  'bpl.ovh',
  'bulmp3.com',
  'bultoc.com',
  'burangir.com',
  'burnermail.io',
  'busines.com',
  'bwmyga.com',
  'californiamail.com',
  'camjoint.com',
  'cawalmart.com',
  'charter.net',
  'chaublog.com',
  'chuan.info',
  'clowtmail.com',
  'co.site',
  'consultant.com',
  'corshash.net',
  'crefree.com',
  'creteanu.com',
  'dallasmail.com',
  'deshnetarchadacalculator.one',
  'disefl.com',
  'divvy.com',
  'dollicons.com',
  'dolofan.com',
  'domain.com',
  'dpl.ovh',
  'drmail.in',
  'duck.com',
  'dv2.host',
  'edmondventures.com',
  'elumlabr.com',
  'email.tst',
  'emailnow.net',
  'emergencymail.site',
  'engineer.com',
  'etc.com',
  'example.com',
  'example.net',
  'ezguru.site',
  'facebook.com',
  'flyymail.com',
  'frm.ovh',
  'futurejs.com',
  'gamil.com',
  'genzmaile.com',
  'genzotp.com',
  'gerix.org',
  'getburner.email',
  'getmoss.com',
  'gettempmail.org',
  'gettranslation.app',
  'gmai.com',
  'gmail.co',
  'gmail.comco',
  'gmail.coml',
  'gmail.site',
  'gmsil.com',
  'gmx.us',
  'hams.com',
  'hengely.com',
  'hmail.com',
  'hot.rr.com',
  'hotmail.coml',
  'hotmail.fr',
  'hutmail.com',
  'hutudns.com',
  'ibymail.com',
  'idcreate.site',
  'idf.ovh',
  'idfd.live',
  'inboxeen.com',
  'infogast.com',
  'insgrmail.site',
  'inupup.com',
  'iplv.ovh',
  'javaemail.com',
  'jayifay.com',
  'ji5.de',
  'kanonmail.com',
  'kaoing.com',
  'kinsef.com',
  'kpl.ovh',
  'lcc.com',
  'ligue-games.art',
  'lnovic.com',
  'lovecalculatorname.org',
  'lumeika.com',
  'mailar.site',
  'mailbeaver.net',
  'maili.cam',
  'mailinator.com',
  'mailru.site',
  'mailru.site',
  'mailshan.com',
  'mailthink.net',
  'mamabood.com',
  'mediaeast.uk',
  'mediaholy.com',
  'meltp.com',
  'mfxis.com',
  'mirosoft.com',
  'mkzaso.com',
  'mofagrac.online',
  'mohemil.com',
  'mpk.ovh',
  'mrotzis.com',
  'msn.co',
  'mtempmail.com',
  'myyahoo.com',
  'netoiu.com',
  'no.com',
  'nobinbox.com',
  'nrehi.com',
  'oeralb.com',
  'oku.ovh',
  'oky.ovh',
  'okymail.site',
  'onestiqu.com',
  'ostahie.com',
  'outllook.com',
  'outloo.com',
  'outlook.comp',
  'outlook.es',
  'ozsaip.com',
  'pazuric.com',
  'pdf-cutter.com',
  'pixoldge.net',
  'pixoledge.net',
  'pkmail.site',
  'pm.me',
  'pmail.site',
  'pngk.uk',
  'poolment.com',
  'priyo.site',
  'priyoemail.site',
  'priyotv.one',
  'priyp.com',
  'proton.com',
  'proton.me',
  'prueba.com',
  'push.tg',
  'radexi.com',
  'radexi.info',
  'rapidmail.online',
  'relayfi.com',
  'rivken.com',
  'rotogum.com',
  'rotogum.info',
  'rulersonline.com',
  'ruutukf.com',
  'safelyment.com',
  'seaswar.com',
  'sevitahealth.com',
  'sgm.ovh',
  'sisood.com',
  'skiff.com',
  'sonarupardam.blog',
  'suarj.com',
  'sudarin.com',
  'sudarin.info',
  'superbowlstarttime.org',
  'swagpapa.com',
  'teligmail.site',
  'tempmail.ing',
  'tempmail.us.com',
  'tempmailgenerator.co',
  'tempyx.com',
  'tenwmail.com',
  'test.com',
  'test2.com',
  'testingtesting.com',
  'teszari.com',
  'timail.site',
  'tmre.site',
  'tppp.one',
  'tppp.online',
  'trykarat.com',
  'tryramp.co',
  'twdol.com',
  'ukm.ovh',
  'usa.com',
  'uselesswebsites.net',
  'usm.ovh',
  'vip.sina.com',
  'vonju.org',
  'whitehousecalculator.com',
  'wnbaldwy.com',
  'xkxkud.com',
  'xterps.com',
  'xyz.com',
  'yah.com',
  'yahoo.co.in',
  'yahoo.fr',
  'yayhoo.com',
  'yhaoo.com',
  'ymail.com',
  'ymeli.com',
  'yzcalo.com',
  'zatempmail.co',
  'zatempmail.com',
  'zohomail',
]

export function isValidEmail(emailAddress?: string | null): boolean {
  if (!emailAddress) {
    return false
  }

  // Match exact domain or subdomains (e.g. "usa.com" and "mail.usa.com")
  // but not unrelated domains containing the blocked string (e.g. "quasarusa.com")
  const emailDomain = getEmailDomain(emailAddress)
  const blockedEmail = blockedEmailDomains.some(
    (domain) => emailDomain === domain || emailDomain.endsWith(`.${domain}`)
  )
  if (blockedEmail) {
    return false
  }

  return getEmailErrorString()(emailAddress) === undefined
}

function isPersonalEmail(emailAddress: string): boolean {
  return personalEmailDomains.some((domain) => emailAddress.includes(domain))
}

export function getPersonalEmailError(emailAddress: string): string | undefined {
  if (isPersonalEmail(emailAddress)) {
    return BUSINESS_EMAIL_ERROR
  }

  return undefined
}

export function getEmailDomain(email: string): string {
  return email.split('@')[1]
}

export function isValidEmailMessage(emailAddress?: string | null): string | undefined {
  if (!emailAddress) {
    return 'Please enter an email address.'
  }

  if (getEmailErrorString()(emailAddress)) {
    return 'Invalid email address.'
  }

  // Match exact domain or subdomains (e.g. "usa.com" and "mail.usa.com")
  // but not unrelated domains containing the blocked string (e.g. "quasarusa.com")
  const emailDomain = getEmailDomain(emailAddress)
  const blockedEmail = blockedEmailDomains.some(
    (domain) => emailDomain === domain || emailDomain.endsWith(`.${domain}`)
  )
  if (blockedEmail) {
    return BLOCKED_EMAIL_ERROR
  }
}

export function isValidEmailNoPersonalMessage(emailAddress?: string | null): string | undefined {
  const invalidEmailMessage = isValidEmailMessage(emailAddress)

  if (!emailAddress || invalidEmailMessage) {
    return invalidEmailMessage
  }

  const personalEmail = personalEmailDomains.some((domain) => emailAddress.includes(domain))
  if (!personalEmail) {
    return
  }

  return BUSINESS_EMAIL_ERROR
}

type GetMailToLinkParams = {
  to: string
  cc?: string
  subject?: string
  body?: string
}

export function getMailToLink({
  to: consumerTo,
  cc: consumerCc = '',
  subject: consumerSubject = '',
  body: consumerBody = '',
}: GetMailToLinkParams) {
  const to = encodeURIComponent(consumerTo.trim())
  const cc = encodeURIComponent(consumerCc.trim())
  const subject = encodeURIComponent(consumerSubject.trim())
  const body = encodeURIComponent(consumerBody.trim())

  const prefix = `mailto:${to}`

  const query = []

  if (cc) {
    query.push(`cc=${cc}`)
  }

  if (subject) {
    query.push(`subject=${subject}`)
  }

  if (body) {
    query.push(`body=${body}`)
  }

  const queryString = query.join('&')

  if (queryString) {
    return [prefix, queryString].join('?')
  }

  return prefix
}
